module.exports = __webpack_public_path__ + "img/ic_invite_download_apple.31366c8.svg";